export const CopyIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
      strokeLinejoin="round"
      stroke="currentColor"
      {...props}
    >
      <g>
        <path d="M16.5714 8H23V23H8V16.5714" />
        <path d="M16 1H1V16H16V1Z" />
      </g>
    </svg>
  );
};
